const LISTINGS = 'listings';
const AUCTIONS = 'auctions';

export { LISTINGS, AUCTIONS };
